module.exports = "/_next/static/images/uv-hint-6c771d7a4f3f650282e0d01fde78a5e0.png";